import { createPortal } from 'react-dom'
import { useEffect, useId, useRef, useState } from 'react'
import { LINE_ADMIN_KEYWORD, LINE_CONTACT_BOT2, LINE_ID_BOT2 } from '../config/env'

const ADMIN_CHAT_URL = `https://line.me/R/oaMessage/${encodeURIComponent(LINE_ID_BOT2)}/?${encodeURIComponent(LINE_ADMIN_KEYWORD)}`

/** A quiet contact control shared by the landing page and member account. */
export function AdminContact({ className = '', onOpen }: { className?: string; onOpen?: () => void }) {
  const [open, setOpen] = useState(false)
  const titleId = useId()
  const dialogRef = useRef<HTMLDialogElement>(null)
  const triggerRef = useRef<HTMLButtonElement>(null)
  useEffect(() => {
    if (!open || !dialogRef.current) return
    const dialog = dialogRef.current
    const trigger = triggerRef.current
    const previousOverflow = document.body.style.overflow
    document.body.style.overflow = 'hidden'
    dialog.showModal()
    return () => {
      dialog.close()
      document.body.style.overflow = previousOverflow
      if (trigger?.isConnected && trigger.getClientRects().length) trigger.focus()
    }
  }, [open])

  return <>
    <button ref={triggerRef} type="button" className={`mo-contact-admin ${className}`.trim()} aria-haspopup="dialog" onClick={() => { onOpen?.(); setOpen(true) }}>
      <i className="far fa-comment-dots" aria-hidden="true" />ติดต่อแอดมิน
    </button>
    {open && createPortal(<dialog ref={dialogRef} className="mo-admin-dialog" aria-labelledby={titleId} onCancel={() => setOpen(false)} onClick={(event) => {
      if (event.target !== event.currentTarget) return
      const rect = event.currentTarget.getBoundingClientRect()
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) setOpen(false)
    }}>
      <button type="button" className="mo-admin-close" aria-label="ปิดหน้าต่าง" onClick={() => setOpen(false)} autoFocus>×</button>
      <h2 id={titleId}>ติดต่อศรีคเนศ เทวาลัย</h2>
      <p>สอบถามข้อมูลออร์เดอร์ หรือขอความช่วยเหลือ</p>
      <p className="mo-admin-line-id">LINE: <b>{LINE_ID_BOT2}</b></p>
      <p className="mo-admin-keyword">ข้อความในช่องแชท: <b>{LINE_ADMIN_KEYWORD}</b><br />กดส่งข้อความใน LINE เพื่อเริ่มติดต่อทีมงาน</p>
      <a className="mo-admin-chat" href={ADMIN_CHAT_URL} target="_blank" rel="noopener noreferrer"><i className="fab fa-line" aria-hidden="true" />เปิดแชท LINE</a>
      <a className="mo-admin-add-friend" href={LINE_CONTACT_BOT2} target="_blank" rel="noopener noreferrer">เพิ่มเพื่อนศรีคเนศ เทวาลัย</a>
    </dialog>, document.body)}
  </>
}
